module.exports = __webpack_public_path__ + "static/media/Linkedin.fafc8a0b.svg";